import { useCallback, useRef, useState } from 'react';

export function useDebounceRerender(delay = 250) {
  const [, rerender] = useState({});
  const rerenderTimeoutRef = useRef<number | null>(null);
  const arrayCallbacksRef = useRef<(() => void)[]>([]);

  return useCallback(
    (callback?: () => void) => {
      if (rerenderTimeoutRef.current) {
        window.clearTimeout(rerenderTimeoutRef.current);
      }

      if (typeof callback === 'function') {
        arrayCallbacksRef.current.push(() => callback());
      }

      rerenderTimeoutRef.current = window.setTimeout(() => {
        arrayCallbacksRef.current.forEach((callback) => callback());
        arrayCallbacksRef.current = [];
        rerender({});
      }, delay);
    },
    [delay]
  );
}

export function useDebounceCallback(callback: () => void, delay = 250) {
  const rerenderTimeoutRef = useRef<number | null>(null);

  return useCallback(() => {
    if (rerenderTimeoutRef.current) {
      window.clearTimeout(rerenderTimeoutRef.current);
    }

    rerenderTimeoutRef.current = window.setTimeout(() => {
      callback();
    }, delay);
  }, [callback, delay]);
}
